<template>
  <div :style="style" class="dash-item">
    <router-link :to="link">
      <i :class="icon"></i>
      <inline-svg v-if="svg" style="margin-bottom: 15px" :src="require(`@/assets/icons/${svg}`)" :fill="color" :height="height"></inline-svg>
      <span>{{title}}</span>
    </router-link>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import InlineSvg from 'vue-inline-svg'
export default {
  name: 'DashItem',
  props: {
    link: {
      type: Object,
      required: true
    },
    icon: {
      type: String
    },
    svg: {
      type: String
    },
    color: {
      type: String
    },
    height: {
      type: String
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    style () {
      if (!this.estilo.aplicacao) { return '' }
      return {
        'background-color': `${this.estilo.aplicacao.corPrimariaAplicacao}0f`
      }
    }
  },
  components: {
    InlineSvg
  }
}
</script>
